const NAMESPACE = "_projectPageLayout";

const KEYS = {
    goToText: "goToText",
    goButton: "goButton",
    adminText: "adminText",
    viewEditText: "viewEditText",
    gotoViewEditButton: "gotoViewEditButton",
    gotoAdminButton: "gotoAdminButton"
};

const MESSAGES = {
    [KEYS.goToText]: {
        value: "Go to",
        comment: "Preface for Go to project text and button"
    },
    [KEYS.goButton]: {
        value: "Go",
        comment: "Text for Go button"
    },
    [KEYS.adminText]: {
        value: "Admin:",
        comment: "Text for Admin page header"
    },
    [KEYS.viewEditText]: {
        value: "View/Edit:",
        comment: "Text for View/Edit page header"
    },
    [KEYS.gotoViewEditButton]: {
        value: "Go To View/Edit",
        comment: "Text for go to view/edit button"
    },
    [KEYS.gotoAdminButton]: {
        value: "Go To Admin",
        comment: "Text for go to admin button"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
